import { call, put, takeLeading } from 'redux-saga/effects';
import { servicesActions } from '../reducers/services';
import servicesGateway from '../api/services';

function* servicesDataRequest({ payload }: any): any {
  const res = yield call(servicesGateway.fetchServices, payload);
  if (res.status === 'success') {
    yield put(servicesActions.getServicesDataResponse(res));
  } else {
    yield put(servicesActions.getServicesDataFailed());
  }
}

function* servicesSaga() {
  yield takeLeading('services/getServicesDataRequest', servicesDataRequest);
}

export default servicesSaga;
